import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom'
import {CONFIRM} from "@/common/Constant"
import Confirm from "@/view/common/popup/Confirm"
import StorageUtil from "@/common/StorageUtil";

const Logout = () => {
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false)

    const logout = () => {
        StorageUtil.initStorage()
        navigate("/")
    }


    return (
        <>
            <div className='mrml-24px ptpb-22px border-top-gray text-center b2_l' onClick={() => setIsOpen(true)}>
                로그아웃
            </div>
            <Confirm content={<span>{CONFIRM.LOGOUT.CONTENT}</span>} title={undefined} leftBtnContent={CONFIRM.LOGOUT.LBTN} rightBtnContent={CONFIRM.LOGOUT.RBTN} isOpen={isOpen} onClick={ () => logout()} onClose={ () => setIsOpen(false)}/>
        </>
    )
};

export default Logout;